import { readable, derived } from "svelte/store";
import { State } from "./State";
export class Game {
    constructor(eventsChannelFactory, id, roomId, code, managerId, creationDate, type, state, waitTime, numbers, useCheckers) {
        this.eventsChannelFactory = eventsChannelFactory;
        this.id = id;
        this.roomId = roomId;
        this.code = code;
        this.managerId = managerId;
        this.creationDate = creationDate;
        this.type = type;
        this.waitTime = waitTime;
        this.useCheckers = useCheckers;
        this.timeToStart = readable(this.getTimeToStart(), set => {
            if (this.getTimeToStart() === 0) {
                set(0);
                return;
            }
            const timeout = window.setInterval(() => {
                const timeToStart = this.getTimeToStart();
                //Si no queda tiempo detenemos el intervalo
                if (timeToStart === 0) {
                    window.clearInterval(timeout);
                }
                set(timeToStart);
            }, 1000);
            return () => window.clearInterval(timeout);
        });
        this.waitingEnded = derived(this.timeToStart, timeToStart => timeToStart === 0);
        this.state = new State(state);
        this.numbers = new State(numbers);
    }
    getEventsChannel() {
        return this.eventsChannelFactory.createEventsChannel(`game.${this.id}`);
    }
    hasNumber(number) {
        return this.numbers.value.includes(number);
    }
    addNumber(numbers) {
        if (!numbers.length) {
            return;
        }
        this.numbers.value = numbers;
        this.numbers.beat();
    }
    /**
     * Retorna el tiempo en segundos que faltan para que comience el juego.
     * No retornará números negativos.
     */
    getTimeToStart() {
        const startTime = this.creationDate.getTime() + (this.waitTime * 60 * 1000);
        return Math.max(0, Math.floor((startTime - Date.now()) / 1000));
    }
}
